// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type WorkspaceEntitlementsQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type WorkspaceEntitlementsQuery = { __typename?: 'Query', workspaceEntitlements: { __typename?: 'WorkspaceEntitlements', workspaceId: string, organizationId: string, plan: Types.OrganizationPlanCode, isOrganizationOwner: boolean, features: Array<{ __typename?: 'WorkspaceEntitlement', key: Types.WorkspaceEntitlementKey, eligibleByPlan: boolean, enabled: boolean, hasPermission: boolean, platformEnabled: boolean, reason: string }> } };


export const WorkspaceEntitlementsDocument = gql`
    query WorkspaceEntitlements($workspaceId: ID!) {
  workspaceEntitlements(workspaceId: $workspaceId) {
    workspaceId
    organizationId
    plan
    isOrganizationOwner
    features {
      key
      eligibleByPlan
      enabled
      hasPermission
      platformEnabled
      reason
    }
  }
}
    `;

/**
 * __useWorkspaceEntitlementsQuery__
 *
 * To run a query within a React component, call `useWorkspaceEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceEntitlementsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceEntitlementsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables> & ({ variables: WorkspaceEntitlementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>(WorkspaceEntitlementsDocument, options);
      }
export function useWorkspaceEntitlementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>(WorkspaceEntitlementsDocument, options);
        }
// @ts-ignore
export function useWorkspaceEntitlementsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>;
export function useWorkspaceEntitlementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceEntitlementsQuery | undefined, WorkspaceEntitlementsQueryVariables>;
export function useWorkspaceEntitlementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>(WorkspaceEntitlementsDocument, options);
        }
export type WorkspaceEntitlementsQueryHookResult = ReturnType<typeof useWorkspaceEntitlementsQuery>;
export type WorkspaceEntitlementsLazyQueryHookResult = ReturnType<typeof useWorkspaceEntitlementsLazyQuery>;
export type WorkspaceEntitlementsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceEntitlementsSuspenseQuery>;
export type WorkspaceEntitlementsQueryResult = ApolloReactCommon.QueryResult<WorkspaceEntitlementsQuery, WorkspaceEntitlementsQueryVariables>;